import { Link } from '@tanstack/react-router'
import { ColumnDef } from '@tanstack/react-table'
import type { CustomBanner } from 'api/generated'
import { Button } from 'components/ui/button'

export interface BannersColumnsProps {
  onDeleteBanner: (id: number) => void
}

export const customBannersColumns = (
  props: BannersColumnsProps
): ColumnDef<CustomBanner>[] => [
  {
    accessorKey: 'id',
    header: 'ID',
  },
  {
    accessorKey: 'image',
    header: 'Immagine',
    cell: ({ row }) =>
      row.original.image != null && (
        <img
          src={row.original.image}
          alt='Custom Banner'
          className='max-h-40 max-w-xs'
        />
      ),
  },
  {
    accessorKey: 'destination',
    header: 'Destinazione',
    cell: ({ row }) =>
      row.original.destination != null && (
        <a
          href={row.original.destination}
          target='_blank'
          rel='noopener noreferrer'
        >
          {row.original.destination}
        </a>
      ),
  },
  {
    accessorKey: 'id', // Using id as a key for actions
    header: 'Azioni',
    cell: ({ row }) => (
      <div className='flex items-center gap-2'>
        <Link
          to='/custom-banner/$id/modifica'
          params={{ id: row.original.id.toString() }}
        >
          Modifica
        </Link>
        <Button
          size='sm'
          variant='destructive'
          onClick={() => {
            if (
              window.confirm('Sei sicuro di voler eliminare questo banner?')
            ) {
              props.onDeleteBanner(row.original.id)
            }
          }}
        >
          Elimina
        </Button>
      </div>
    ),
  },
]
